import * as GoogleAnalytics from "@kleinanzeigen/google-analytics";
const { trackEvent, eventStringToObject } = GoogleAnalytics;

export interface GATrackingEvent {
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
}

function getLocation(): string {
  return window.location.origin + window.location.pathname;
}

export function trackGAEvent(event: GATrackingEvent, location?: string): void {
  const { eventCategory, eventAction, eventLabel } = event;
  const trackingLocation = location || getLocation();

  trackEvent(
    { eventCategory, eventAction, eventLabel },
    { location: trackingLocation },
    { dimension1: eventCategory },
  );
}

export function trackEventString(event: string): void {
  const eventObject = eventStringToObject(event);
  const trackingLocation = getLocation();

  trackEvent(
    eventObject,
    { location: trackingLocation },
    { dimension1: eventObject.eventCategory },
  );
}
